/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from "react";
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
} from "@syncfusion/ej2-react-grids";
import { interestsGrid } from "../data/dummy";
import { Header } from "../components";
import { useThemeContext } from "../contexts/ThemeContextProvider";
import { Link, useLocation } from "react-router-dom";
import { useInterestsContext } from "../contexts/InterestsContextProvider";
import { useAuthContext } from "../contexts/AuthContextProvider";
import DeleteConfirmationModal from "../components/DeleteConfirmationModel";

const Interests = () => {
  const { currentColor } = useThemeContext();
  const toolbarOptions = ["Search"];
  const { allInterests, getAllInterests, deleteEverything } =
    useInterestsContext();
  const { checkIsLogin, isLogin, currentUser } = useAuthContext();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteInterestId, setDeleteInterestId] = useState(null);
  const [back, setBack] = useState(-1);

  useEffect(() => {
    localStorage.removeItem("currentPage");
  }, []);
  useEffect(() => {
    checkIsLogin();

    return () => {
      checkIsLogin();
    };
  }, [checkIsLogin]);

  useEffect(() => {
    if (isLogin) {
      getAllInterests(currentUser["token"]);
    }
  }, [getAllInterests, isLogin, currentUser]);

  const editing = { allowDeleting: true, allowEditing: true };

  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const deleteId = urlParams.get("delete");
    if (deleteId) {
      console.log("Delete ID:", deleteId);
      setDeleteInterestId(deleteId);
      setBack((prevBack) => prevBack - 1);
      setShowDeleteConfirmation(true);
    } else {
      console.log("No delete ID found.");
    }
  }, [location.search, location]);

  const handleDelete = async (id) => {
    try {
      setDeleteLoading(true);
      // Call the API to delete the sub-bucket
      const result = await deleteEverything(
        currentUser["token"],
        "Interest",
        id
      );

      if (!result) {
        throw new Error("Data not Deleted");
      }
      // Refresh the data after successful deletion
      getAllInterests(currentUser["token"]);
    } catch (error) {
      console.error("Error during delete:", error);
    } finally {
      setShowDeleteConfirmation(false);
      setDeleteInterestId(null);
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("delete");
      const newUrl = `${window.location.pathname}`;
      window.history.replaceState({}, "", newUrl);
      setDeleteLoading(false);
    }
  };

  return (
    <div className='pt-24 pb-10 bg-gray-100 md:py-2 '>
      {allInterests ? (
        <div className='p-2 m-2 bg-white md:m-10 md:p-10 rounded-3xl'>
          <Header category='Page' title='Bucket' back={back} />

          <div className='w-full flex items-center justify-end my-3 mt-5'>
            {/* submit button */}
            <Link to='/bucket/category/add'>
              <button
                style={{ backgroundColor: currentColor }}
                type='submit'
                className='h-10 px-10 text-white transition-colors duration-150 rounded-lg focus:shadow-outline'>
                Add Bucket
              </button>
            </Link>
          </div>
          <GridComponent
            dataSource={allInterests}
            width='auto'
            allowPaging
            allowSorting
            pageSettings={{ pageCount: 5 }}
            editSettings={editing}
            toolbar={toolbarOptions}>
            <ColumnsDirective>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              {interestsGrid.map((item, index) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject services={[Search, Page]} />
          </GridComponent>
          {/* Delete Confirmation Modal */}
          <DeleteConfirmationModal
            isOpen={showDeleteConfirmation}
            onClose={() => {
              setShowDeleteConfirmation(false);
              setDeleteInterestId(null);
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.delete("delete");
              const newUrl = `${window.location.pathname}`;
              window.history.replaceState({}, "", newUrl);
            }}
            loading={deleteLoading}
            onDelete={() => handleDelete(deleteInterestId)} // Assuming you want to delete the current interest
          />
        </div>
      ) : (
        <div className='p-2 m-2 bg-white md:m-10 md:p-10 rounded-3xl'>
          <h5 className='text-center font-bold text-md'>Loading ....</h5>
        </div>
      )}
    </div>
  );
};
export default Interests;
